export default __webpack_public_path__ + "static/services-3e5d536f098056120e704604f31cd901.jpg";